import { createFileRoute } from '@tanstack/react-router'

import { AiDeclineJourneysScreen } from './-components/ai-decline-journeys-screen.tsx'

export const Route = createFileRoute('/reports/ai-decline-journeys')({
  component: AiDeclineJourneysScreen
})
